import React, { Suspense, lazy } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { 
  //BrowserRouter as Router, 
  Routes,
  Route, 
  useLocation,
} from 'react-router-dom';

import Header from './components/Header';
import SideBar from './components/Sidebar';
import TasksList from './components/TasksList';
import Profile from './components/Profile';
import { FormPage, FormPageAppProvider } from '@lk/form-renderer';
import Loader from './components/common/Loader';
import ConfirmationModal from './components/common/ConfirmationModal';

//import axios from 'axios';
import axios_api from './Api';
import { API_URL, AUTH_TOKEN } from './Context';


function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  return null;
}


function ProtectedPages({setAuthToken, appUserName, setAppUserName}) {
 
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN); 
  
  function SyncProfile(userProfileNext){
    let profileObject = userProfileNext

    axios_api.post(api_url + `/profile/`, profileObject, {
      headers: {"Authorization": token}
    })
    .then(
      (result) => {
        //console.log("sending ShoppingCart");
      },
      (error) => {console.log(error)}
    );
  }


  return(
    <FormPageAppProvider
      apiClient={axios_api}
      apiUrlContext={API_URL}
      authTokenContext={AUTH_TOKEN}
      Loader={Loader}
      ConfirmationModal={ConfirmationModal}
    >
    <>
      <ScrollToTop />
      <Header 
        setAuthToken={setAuthToken} 
        appUserName={appUserName} 
        setAppUserName={setAppUserName}
      /> 
      <div className="row plato">
        <div className="col-2 fixed-top vh-100 p-0 left-panel-wrapper">
          <SideBar
          />
        </div>
        <div className="col-2"></div>
        <div className="col-10 border-start px-4 pb-4 right-panel">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/profile" element={
                <Profile 
                  syncProfile={SyncProfile}
                />
              }/>                   
              <Route exact path="/" element={
                <TasksList/>
              }/>           
              <Route path="/task/:taskId" element={
                <FormPage
                  formMode="expert"
                  taskUrl="/expert_form_task/"
                />
              }/>
            </Routes>
          </Suspense>  
        </div>
      </div>
    </>
    </FormPageAppProvider>
  )
}

export default ProtectedPages